/* eslint-disable no-plusplus */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { confirmAlert } from 'react-confirm-alert'
import styles from './home.module.css'

const JurosSimples = () => {
  const [linkToRedirect, setLinkToRedirect] = useState(null)

  const handleClick = link => {
    setLinkToRedirect(link)
  }

  if (linkToRedirect) {
    return <Redirect to={linkToRedirect} />
  }

  const showWarning = () => {
    return confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className={styles.important}>
            <h1>Importante</h1>
            <p>
              {`O aplicativo “Calculadora Financeira AP” realiza todos os cálculos financeiros de forma automática. Assim, na medida em que os dados dos problemas vão sendo imputados pelo usuário, o aplicativo pode emitir mensagens intermediárias, do tipo 'ERRO' e 'i < 0', que podem ser alteradas após o fornecimento de todos os parâmetros, que conduz à obtenção do valor correto da incógnita.`}{' '}
            </p>
            <button
              className={styles.alertButton}
              onClick={() => {
                onClose()
              }}
            >
              Entendido
            </button>
          </div>
        )
      },
    })
  }

  return (
    <>
      <header>
        <nav id="tm-header" className={styles.tmHeader}>
          <div className={styles.logoHeader}>
            <img
              src="assets/img/logo.png"
              alt="Saraiva Conecta Conte�do Digital"
              title="Saraiva Conecta Conte�do Digital"
            />
          </div>
        </nav>
      </header>
      <section>
        <article>
          <div className={styles.infoContent}>
            <p>CALCULADORA FINANCEIRA – AP </p>
            <p>
              <a target="_blank" href="/ajuda.pdf">
                (Ajuda)
              </a>
            </p>
            <p className={styles.infoModal} onClick={() => showWarning()}>
              (Informação importante)
            </p>
            <p>
              Autor: Abelardo Puccini - MSc
              <br />
              Stanford University
            </p>
            <p>
              Livro: Matemática Financeira Objetiva e Aplicada – 10ª Edição
              <br />
              Editora Saraiva
            </p>
          </div>
        </article>

        <article>
          <button
            className={styles.btnCalculadora}
            onClick={() => handleClick('/juros-simples')}
          >
            Juros Simples
          </button>
        </article>

        <article>
          <button
            className={styles.btnCalculadora}
            onClick={() => handleClick('/juros-compostos')}
          >
            Juros Compostos – Diagrama Padrão
          </button>
        </article>

        <article>
          <button
            className={styles.btnCalculadora}
            onClick={() => handleClick('/juros-compostos-heterogenios')}
          >
            Juros Compostos – Fluxos Heterogêneos
          </button>
        </article>
      </section>
      <footer>
        <div className={styles.footer}>
          Calculadora Financeira | Prof. Puccini
        </div>
      </footer>
    </>
  )
}

export default JurosSimples
